import { getHeaders } from "utils/header";
import { getEnvProps } from "utils/helper/server-helper";
import { Product, ProductData, ProductResponse } from "utils/types/products";

export type ProductValidationErrors = {
  image?: string;
  icon?: string;
  name?: string;
};

export const getProductBySlug = async (
  slug: string
): Promise<ProductResponse | null> => {
  const envProps = await getEnvProps();
  const headers = await getHeaders(undefined, true);

  let product: Product | null = null;

  try {
    const req = await fetch(
        `${envProps.base_url}/api/v1/vendor/get-product/${slug}`,
        {
          headers,
        }
      ),
      res = await req.json();
    console.log(res);

    if (res.success != null && res.success) {
      return res.data;
    } else {
      throw new Error("Error 404, Brand not found.");
    }
  } catch (error) {
    console.error("Error fetching Product:", error);
    // throw new Error("Error fetching brand");
  }

  return product;
};

export const getProducts = async (): Promise<Product[] | null> => {
  const envProps = await getEnvProps();
  const headers = await getHeaders(undefined, true);

  let products: Product[] | null = null;

  try {
    const req = await fetch(`${envProps.base_url}/api/v1/vendor/product`, {
        headers,
      }),
      res = await req.json();
    console.log(res);

    if (res.success != null && res.success) {
      return res.data;
    } else {
      throw new Error("Error 404, Products not found.");
    }
  } catch (error) {
    console.error("Error fetching Product:", error);
    // throw new Error("Error fetching Products");
  }

  return products;
};

export const getProductsData = async (): Promise<ProductData[] | null> => {
  const envProps = await getEnvProps();
  const headers = await getHeaders(undefined, true);

  let products: ProductData[] | null = null;

  try {
    const req = await fetch(`${envProps.base_url}/api/v1/vendor/products`, {
        headers,
      }),
      res = await req.json();
    console.log(res);

    if (res.success != null && res.success) {
      return res.data;
    } else {
      throw new Error("Error 404, Products not found.");
    }
  } catch (error) {
    console.error("Error fetching Product:", error);
    // throw new Error("Error fetching Products");
  }

  return products;
};
